import React, { useState, useEffect } from "react";
import { Link, Switch, Route, useHistory } from "react-router-dom";

import { Avatar, Dropdown, Icon, Layout, Menu, Row } from "antd";

import moment from "moment";

import UserImg from "../../../media/profile-img.jpg";
import logo from "../../../media/CosmoName.png";

import "../../dashboard/dashboard.less";
import WhatsNewApp from "../whats-new-app/WhatsNewApp";
import Rollout from "views/rollout/Rollout";
import FeatureDetails from "views/rollout/FeatureDetails";
import MultiCountry from "../multi-country/MultiCountry";
import ErrorLog from "../error-log/ErrorLog";
import CountryConfugrationDetails from "views/developer-section/multi-country/CountryConfugrationDetails";

import DateComponent from "components/DateComponent/DateComponent";
import ReactCountryFlag from "react-country-flag";
import { TranslationOutlined } from "@ant-design/icons";
import MultiLanguage from "../multi-language/MultiLanguage";
import CountryInfo from "../multi-country/CountryInfo";

const { Sider, Content } = Layout;

const DeveloperDash = ({ ...props }) => {
	const history = useHistory();
	const [page, setPage] = useState(history.location.pathname.split("/")[1] === "" ? "whats-new-app" : history.location.pathname.split("/")[1]);
	let username = localStorage.getItem("username");

	const handleLogout = () => {
		localStorage.clear();
		history.go(0);
	};

	useEffect(() => {
		setPage(history.location.pathname.split("/")[1] === "" ? "whats-new-app" : history.location.pathname.split("/")[1]);
	}, [history.location.pathname]);

	return (
		<>
			<Layout>
				<div
					style={{
						position: "fixed",
						top: "0",
						right: "0",
						width: "100%",
						padding: "15px 30px",
						// background: "#FAFAFA",
						// zIndex: "10",
						// boxShadow:"0 2px rgba(0, 0, 0, 0.1)"
					}}>
					<Row type="flex" align="middle" justify="end" className="header-container">
						<DateComponent />
						<Dropdown
							overlay={
								<Menu mode="horizontal">
									<Menu.Item>
										<a onClick={handleLogout}>Logout</a>
									</Menu.Item>
								</Menu>
							}
							trigger={["click"]}>
							<a className="ant-dropdown-link" style={{ textTransform: "capitalize", fontSize: "14px" }}>
								<Avatar size={32} src={UserImg} className="margin-right-5" />
								{username} <Icon type="down" style={{ color: "#6E7191" }} />
							</a>
						</Dropdown>
					</Row>
				</div>

				<Layout>
					<Sider
						style={{
							background: "#272727",
							position: "fixed",
							top: 0,
							bottom: 0,
							overflow: "hidden",
							zIndex: 20,
							// paddingTop: 40
							// color: "#fff"
						}}
						trigger={null}
						collapsible
						// collapsed={this.state.collapsed}
						// className={this.state.collapsed ? "hide-on-small" : "overlay " + "sider"}
					>
						<div className="logo" style={{ display: "flex", alignItems: "flex-end" }}>
							<img
								src={logo}
								style={{
									height: "40px",
                                    width: "100px",
								}}
							/>
							<ReactCountryFlag
								countryCode={JSON.parse(localStorage.getItem("countryData"))?.short_name || "AE"}
								svg
								style={{
									height: "23px",
									width: "23px",
									borderRadius: "20px",
									backgroundColor: "black",
									objectFit: "cover",
									marginLeft: "5px",
									alignSelf:'center'
								}}
							/>
						</div>

						<Menu
							mode="inline"
							style={{
								backgroundColor: "#272727",
							}}
							defaultSelectedKeys={[page]}
							onSelect={({ key }) => {
								setPage(key);
							}}>
							<Menu.Item key="whats-new-app">
								<Link to="/whats-new-app">
									<div
										style={
											page === "whats-new-app"
												? {
														background: "linear-gradient(90deg, rgba(255, 255, 255, 0.12) 0%, rgba(255, 255, 255, 0) 100%)",
														margin: "0 -16px",
														padding: "0 16px",
												  }
												: {}
										}>
										<Icon
											type="mobile"
											style={{ fontSize: "16px", color: "rgba(255,255,255,0.8)" }}
											theme={page === "whats-new-app" ? "filled" : "outlined"}
										/>
										<span
											style={{
												fontSize: "16px",
												color: "rgba(255,255,255,0.8)",
												lineHeight: "22px",
												fontWeight: `${page === "whats-new-app" ? "bold" : "normal"}`,
											}}>
											What's New | App
										</span>
									</div>
								</Link>
							</Menu.Item>
							<Menu.Item key="rollout">
								<Link to="/rollout">
									<div
										style={
											page === "rollout"
												? {
														background: "linear-gradient(90deg, rgba(255, 255, 255, 0.12) 0%, rgba(255, 255, 255, 0) 100%)",
														margin: "0 -16px",
														padding: "0 16px",
												  }
												: {}
										}>
										<Icon
											type="shop"
											style={{ fontSize: "16px", color: "rgba(255,255,255,0.8)" }}
											// theme={page === "cohorts" ? "filled" : "outlined"}
										/>
										<span
											style={{
												fontSize: "16px",
												color: "rgba(255,255,255,0.8)",
												lineHeight: "22px",
												fontWeight: `${page === "rollout" ? "bold" : "normal"}`,
											}}>
											Rollout Features
										</span>
									</div>
								</Link>
							</Menu.Item>
							<Menu.Item key="countryInfo">
								<Link to="/countryInfo">
									<div
										style={
											page === "countryInfo"
												? {
														background: "linear-gradient(90deg, rgba(255, 255, 255, 0.12) 0%, rgba(255, 255, 255, 0) 100%)",
														margin: "0 -16px",
														padding: "0 16px",
												  }
												: {}
										}>
										<Icon
											type="shop"
											style={{ fontSize: "16px", color: "rgba(255,255,255,0.8)" }}
											// theme={page === "cohorts" ? "filled" : "outlined"}
										/>
										<span
											style={{
												fontSize: "16px",
												color: "rgba(255,255,255,0.8)",
												lineHeight: "22px",
												fontWeight: `${page === "countryInfo" ? "bold" : "normal"}`,
											}}>
											Country Information
										</span>
									</div>
								</Link>
							</Menu.Item>
							<Menu.Item key="countries">
								<Link to="/countries">
									<div
										style={
											page === "countries"
												? {
														background: "linear-gradient(90deg, rgba(255, 255, 255, 0.12) 0%, rgba(255, 255, 255, 0) 100%)",
														margin: "0 -16px",
														padding: "0 16px",
												  }
												: {}
										}>
										<Icon type="global" style={{ fontSize: "16px", color: "rgba(255,255,255,0.8)" }} theme="outlined" />
										<span
											style={{
												fontSize: "16px",
												color: "rgba(255,255,255,0.8)",
												lineHeight: "22px",
												fontWeight: `${page === "countries" ? "bold" : "normal"}`,
											}}>
											Countries
										</span>
									</div>
								</Link>
							</Menu.Item>
							<Menu.Item key="languages">
								<Link to="/languages">
									<div
										style={
											page === "languages"
												? {
														background: "linear-gradient(90deg, rgba(255, 255, 255, 0.12) 0%, rgba(255, 255, 255, 0) 100%)",
														margin: "0 -16px",
														padding: "0 16px",
												  }
												: {}
										}>
										<TranslationOutlined style={{ fontSize: "16px", color: "rgba(255,255,255,0.8)" }} />
										<span
											style={{
												fontSize: "16px",
												color: "rgba(255,255,255,0.8)",
												lineHeight: "22px",
												fontWeight: `${page === "languages" ? "bold" : "normal"}`,
											}}>
											Languages
										</span>
									</div>
								</Link>
							</Menu.Item>
							<Menu.Item key="error-log">
								<Link to="/error-log">
									<div
										style={
											page === "error-log"
												? {
														background: "linear-gradient(90deg, rgba(255, 255, 255, 0.12) 0%, rgba(255, 255, 255, 0) 100%)",
														margin: "0 -16px",
														padding: "0 16px",
												  }
												: {}
										}>
										<Icon
											type="bug"
											style={{ fontSize: "16px", color: "rgba(255,255,255,0.8)" }}
											// theme={page === "cohorts" ? "filled" : "outlined"}
										/>
										<span
											style={{
												fontSize: "16px",
												color: "rgba(255,255,255,0.8)",
												lineHeight: "22px",
												fontWeight: `${page === "error-log" ? "bold" : "normal"}`,
											}}>
											Error Log
										</span>
									</div>
								</Link>
							</Menu.Item>
						</Menu>
					</Sider>

					<Content
						style={{
							// display: "flex",
							// justifyContent: "center",
							// maxWidth: "1300px",
							margin: "0 0 0 290px",
							background: "#E5E5E5",
							minHeight: "100vh",
							height: "max-content",
						}}>
						<Switch>
							<Route path="/whats-new-app" component={WhatsNewApp} />

							<Route exact path="/rollout" component={Rollout} />

							<Route path="/rollout/:featureId" component={FeatureDetails} />
							<Route exact path="/countries" component={MultiCountry} />
							<Route exact path="/countryInfo" component={CountryInfo} />
							<Route exact path="/languages" component={MultiLanguage} />
							<Route exact path="/error-log" component={ErrorLog} />

							<Route exact path="/countries/:countryId" component={CountryConfugrationDetails} />
							<Route path="/countryInfo/:countryId/:language" component={CountryConfugrationDetails} />
							<Route path="" component={WhatsNewApp} />
							
							<Route
								path="*"
								component={() => (
									<Row
										type="flex"
										justify="space-between"
										align="middle"
										style={{
											width: "100%",
											padding: "40px 25px 0",
											margin: "60px auto 20px",
											backgroundColor: "#FAFAFA",
										}}>
										404 NOT FOUND
									</Row>
								)}></Route>
						</Switch>
					</Content>
				</Layout>
			</Layout>
		</>
	);
};

export default DeveloperDash;
